export const packageChargePlanActionTypes = {
    STORE_PACKAGE_CHARGE_PLANS: 'STORE_PACKAGE_CHARGE_PLANS',
    CLEAR_PACKAGE_CHARGE_PLANS: 'CLEAR_PACKAGE_CHARGE_PLANS',
} as const;
